(function () {
  var BP_SP_MAX = 749;
  var BP_PC_MIN = 990;

  var q = function (selector, context) {
    return (context || document).querySelector(selector);
  };

  var esc = function (value) {
    return String(value == null ? '' : value).replace(/[&<>'"]/g, function (match) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[match];
    });
  };

  var truncate = function (value, length) {
    var text = String(value == null ? '' : value);
    if (text.length <= length) return text;
    return text.slice(0, Math.max(0, length - 3)) + '...';
  };

  var isNew = function (publishedAt) {
    if (!publishedAt) return false;
    var published = new Date(publishedAt).getTime();
    if (Number.isNaN(published)) return false;
    var elapsedDays = (Date.now() - published) / (1000 * 60 * 60 * 24);
    return elapsedDays >= 0 && elapsedDays < 30;
  };

  var parseData = function (scriptEl) {
    if (!scriptEl) return [];
    try {
      var parsed = JSON.parse(scriptEl.textContent || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  };

  var fetchPage = function (url) {
    return fetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        return response.ok ? response.text() : Promise.reject(response.status);
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return parseData(doc.querySelector('[data-aw-style-related-data]'));
      })
      .catch(function () {
        return [];
      });
  };

  var cardHtml = function (item, favoriteIcons) {
    var media = '<img class="aw-style-card__image" src="' + esc(item.image) + '" width="' + (item.imageWidth || '') + '" height="' + (item.imageHeight || '') + '" loading="lazy" alt="' + esc(item.imageAlt || item.title) + '">';
    var badge = isNew(item.publishedAt) ? '<span class="aw-style-card__new">NEW</span>' : '';
    var length = item.length ? '<p class="aw-style-card__length">' + esc(item.length) + '</p>' : '';
    var favoriteIconsHtml = '<span class="aw-style-card__favorite-icon aw-style-card__favorite-icon--outline">' + (favoriteIcons.outline || '') + '</span>' +
      '<span class="aw-style-card__favorite-icon aw-style-card__favorite-icon--fill">' + (favoriteIcons.fill || '') + '</span>';
    var favorite = item.handle
      ? '<button type="button" class="aw-style-card__favorite" data-aw-favorite-button data-favorite-type="style" data-favorite-handle="' + esc(item.handle) + '" data-favorite-url="' + esc(item.url) + '" data-favorite-title="' + esc(item.title) + '" data-favorite-image="' + esc(item.image) + '" data-favorite-image-alt="' + esc(item.imageAlt || item.title) + '" data-favorite-meta="' + esc(item.length) + '" aria-pressed="false" aria-label="お気に入りに追加">' + favoriteIconsHtml + '</button>'
      : '';
    var topRow = (length || favorite) ? '<div class="aw-style-card__top-row">' + length + favorite + '</div>' : '';
    var title = item.title ? '<h3 class="aw-style-card__title">' + esc(item.title) + '</h3>' : '';
    var excerpt = item.stylePoint ? '<p class="aw-style-card__excerpt">' + esc(truncate(item.stylePoint, 42)) + '</p>' : '';
    var salon = item.salon ? '<p class="aw-style-card__salon">' + esc(item.salon) + '</p>' : '';
    var staff = item.staff ? '<p class="aw-style-card__staff">' + esc(item.staff) + '</p>' : '';
    var meta = (salon || staff) ? '<div class="aw-style-card__meta">' + salon + staff + '</div>' : '';
    var body = '<div class="aw-style-card__body">' + topRow + title + excerpt + meta + '</div>';
    var tag = item.url ? 'a' : 'div';
    var href = item.url ? ' href="' + esc(item.url) + '"' : '';
    var linkClass = item.url ? ' aw-link-hover' : '';

    return '<' + tag + ' class="aw-style-card' + linkClass + '"' + href + '>' +
      '<div class="aw-style-card__image-wrap">' + media + badge + '</div>' +
      body +
      '</' + tag + '>';
  };

  var maxItemsFor = function () {
    return window.innerWidth >= BP_PC_MIN ? 5 : 6;
  };

  function initRelated(root) {
    var groups = {
      staff: q('[data-aw-style-related-group="staff"]', root),
      brand: q('[data-aw-style-related-group="brand"]', root),
      length: q('[data-aw-style-related-group="length"]', root)
    };
    if (!groups.staff && !groups.brand && !groups.length) return;

    var items = parseData(q('[data-aw-style-related-data]', root));
    var totalPages = Number(root.dataset.sourcePages || 1);
    var pageParam = root.dataset.sourcePageParam || 'page';
    var currentHandle = root.dataset.currentHandle || '';
    var currentStaff = root.dataset.currentStaff || '';
    var currentBrand = root.dataset.currentBrand || '';
    var currentLength = root.dataset.currentLength || '';
    var sortBy = root.dataset.sortBy === 'published_at' ? 'published_at' : 'display_order';
    var favoriteIcons = {
      outline: root.dataset.favoriteIconSvg || '',
      fill: root.dataset.favoriteIconFillSvg || ''
    };

    var sortItems = function (list) {
      var copy = list.slice();
      if (sortBy === 'published_at') {
        copy.sort(function (a, b) {
          var aTime = a.publishedAt ? new Date(a.publishedAt).getTime() : 0;
          var bTime = b.publishedAt ? new Date(b.publishedAt).getTime() : 0;
          if (Number.isNaN(aTime)) aTime = 0;
          if (Number.isNaN(bTime)) bTime = 0;
          return bTime - aTime;
        });
        return copy;
      }
      copy.sort(function (a, b) {
        return Number(a.displayOrder || 999999) - Number(b.displayOrder || 999999);
      });
      return copy;
    };

    var renderGroup = function (groupEl, matched) {
      if (!groupEl) return;
      var grid = q('[data-aw-style-related-grid]', groupEl);
      if (!grid) return;
      var visible = matched.slice(0, maxItemsFor());
      if (!visible.length) {
        groupEl.hidden = true;
        grid.innerHTML = '';
        return;
      }
      grid.innerHTML = visible.map(function (item) { return cardHtml(item, favoriteIcons); }).join('');
      groupEl.hidden = false;

      if (window.awFavorites) window.awFavorites.init(grid);
    };

    var render = function () {
      var pool = sortItems(items.filter(function (item) {
        return !!item.image && item.handle !== currentHandle;
      }));

      if (groups.staff) {
        var byStaff = currentStaff ? pool.filter(function (item) { return item.staffHandle === currentStaff; }) : [];
        renderGroup(groups.staff, byStaff);
      }
      if (groups.brand) {
        var byBrand = currentBrand ? pool.filter(function (item) { return item.brandHandle === currentBrand; }) : [];
        renderGroup(groups.brand, byBrand);
      }
      if (groups.length) {
        var byLength = currentLength ? pool.filter(function (item) { return item.length === currentLength; }) : [];
        renderGroup(groups.length, byLength);
      }
    };

    var loadRemainingPages = function () {
      if (totalPages <= 1) return Promise.resolve();
      var base = new URL(window.location.href);
      base.searchParams.delete(pageParam);
      var jobs = [];
      for (var page = 2; page <= totalPages; page++) {
        var pageUrl = new URL(base);
        pageUrl.searchParams.set(pageParam, page);
        jobs.push(fetchPage(pageUrl.toString()));
      }
      return Promise.all(jobs).then(function (pages) {
        pages.forEach(function (pageItems) {
          items = items.concat(pageItems);
        });
      });
    };

    loadRemainingPages().then(function () {
      var seen = {};
      items = items.filter(function (item) {
        var handle = item.handle || '';
        if (handle && seen[handle]) return false;
        if (handle) seen[handle] = true;
        return true;
      });
      render();
    });

    var resizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(render, 200);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    Array.prototype.forEach.call(document.querySelectorAll('[data-aw-style-related]'), initRelated);
  });
})();
